import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/MISSalesReturnToGr';


const MISSalesReturnToGr = ({ t }) => (
  <Container>
    <Row>
      <Col md={12} style = {{marginBottom : "-25px"}}>
        <h3 className="page-title">REPORTS - Sales Return To Gr </h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

MISSalesReturnToGr.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MISSalesReturnToGr);
